//Review history worked on fixing the page currently working as intended major corrections /-DeveloperVs

// import React, { useEffect, useState } from "react";
// // import "./quespapercorrection.css";
// import BonusQuestionTable from "../../Components/BonusTable/BonusTable";
// import { POST } from "../../Api/HttpsMethods";
// import { GET } from "../../Api/HttpsMethods";
// import EndPoints from "../../Api/EndPoints";
// import DropDown from "../CreateBatch/DropdownCB";
// import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
// import BlankDropdown from "../CreateQuestionsPaper/DppScheduling/BlankDropdown";
// import InputComponent from "../CreateQuestionsPaper/TestScheduling/Input-testscheduling";
// import Colors from "../../Constants/Colors";
// import SearchDropdown from "../../Components/SearchDropdownforListDataSingleSelect/SearchdropdownforlistdataSingleSelect";
// import SuccessImg from "../../Assets/Images/CommanImages/success.png";
// const TestPaperBonusCorrection = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   useEffect(() => {
//     localStorage.removeItem("QuestionCorrectionDetails");
//   }, []);
//   const [bonusRows, setBonusRows] = useState([]);
//   const [allQuestions, setAllQuestions] = useState([]);

//   const [courses, setCourses] = useState([]);
//   const [batches, setBatches] = useState([]);
//   const [testOptions, setTestOptions] = useState([]);

//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [selectedBatch, setSelectedBatch] = useState(null);
//   const [selectedTest, setSelectedTest] = useState(null);
//   const [selectedSet, setSelectedSet] = useState(null);
//   const LOCAL_STORAGE_KEY = "QuestionCorrectionDetails";
//   const [requestedSet, setRequestedSet] = useState(null);

//   useEffect(() => {
//     if (dataClient) {
//       const userName =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//       const clientBranchId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//       const clientId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

//       sessionStorage.setItem("user_name", userName);
//       sessionStorage.setItem("clientBranchId", clientBranchId);
//       sessionStorage.setItem("clientId", clientId);
//     }
//   }, [dataClient]);
//   const userName =
//     dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
//     sessionStorage.getItem("user_name") ||
//     "";
//   // Fetch all courses
//   useEffect(() => {
//     const fetchCourses = async () => {
//       const data = await GET.noToken(EndPoints.GetCourses, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });
//       if (data) setCourses(data);
//     };
//     fetchCourses();
//   }, []);

//   // Fetch batches for selected course
//   useEffect(() => {
//     const fetchBatches = async () => {
//       if (!selectedCourse) return;
//       const url = `${EndPoints.GetBatchByCourse}?course_id=${selectedCourse}`;
//       const data = await GET.noToken(url, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });

//       if (data && Array.isArray(data[0])) setBatches(data[0]);
//       else setBatches([]);

//       setSelectedBatch(null);
//     };
//     fetchBatches();
//   }, [selectedCourse]);

//   // Fetch tests for selected batch
//   useEffect(() => {
//     const fetchTests = async () => {
//       if (!selectedBatch) return;
//       const url = `${EndPoints.GetTestSummarybyBatch}?batch_id=${selectedBatch}`;
//       const response = await GET.withToken(url, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });

//       if (response?.data && Array.isArray(response.data)) {
//         const tests = response.data.map((test) => ({
//           label: test.test_name,
//           id: test.test_schedule_id,
//           ...test,
//         }));
//         setTestOptions(tests);
//       } else {
//         setTestOptions([]);
//       }
//     };
//     fetchTests();
//   }, [selectedBatch]);

//   // Fetch questions for selected test and set
//   useEffect(() => {
//     // const fetchQuestionsForSet = async () => {
//     //   if (!selectedTest?.id || !selectedSet) return;
//     //   const url = `${EndPoints.GetQuestionsfromSetName}?test_schedule_id=${selectedTest.id}&set_name=${selectedSet}`;
//     //   const response = await GET.withToken(url, {
//     //     setMessageBox,
//     //     setIsMessageBoxVisible,
//     //     setActiveImg,
//     //     ErrorImg,
//     //   });

//     //   if (response?.status === 200 && Array.isArray(response.data)) {
//     //     const allQs = response.data
//     //       .filter((q) => q.ques_number != null)
//     //       .map((q) => ({
//     //         id: q.ques_id,
//     //         ques_number: q.ques_number,
//     //         ques_text: convertLatexToHTML(q.ques_text),
//     //         special_status: q.special_status || false,
//     //       }));

//     //     setAllQuestions(allQs);

//     //     const existing = JSON.parse(
//     //       localStorage.getItem("QuestionCorrectionDetails") || "{}"
//     //     );
//     //     existing[selectedSet] = allQs;
//     //     localStorage.setItem(
//     //       "QuestionCorrectionDetails",
//     //       JSON.stringify(existing)
//     //     );

//     //     setBonusRows([
//     //       {
//     //         id: Date.now(),
//     //         questionNo: "",
//     //         questionText: "",
//     //         bonusMarks: 0,
//     //         reason: "Reason to give Bonus Marks",
//     //         attempted: "Only attempted",
//     //         selected: false,
//     //       },
//     //     ]);
//     //   } else {
//     //     setAllQuestions([]);
//     //     setBonusRows([]);
//     //   }
//     // };
//     const fetchQuestionsForSet = async () => {
//       if (!selectedTest?.id || !selectedSet) return;
//       try {
//         const url = `${EndPoints.GetQuestionsfromSetName}?test_schedule_id=${selectedTest.id}&set_name=${selectedSet}`;
//         const response = await GET.withToken(url, {
//           setMessageBox,
//           setIsMessageBoxVisible,
//           setActiveImg,
//           ErrorImg,
//         });

//         if (response?.status === 200 && Array.isArray(response.data)) {
//           const allQs = response.data
//             .filter((q) => q.ques_number != null)
//             .map((q) => ({
//               id: q.ques_id,
//               ques_number: q.ques_number,
//               ques_text: convertLatexToHTML(q.ques_text),
//               special_status: q.special_status || false,
//             }));

//           setAllQuestions(allQs);

//           const existing = JSON.parse(
//             localStorage.getItem("QuestionCorrectionDetails") || "{}"
//           );
//           existing[selectedSet] = allQs;
//           localStorage.setItem(
//             "QuestionCorrectionDetails",
//             JSON.stringify(existing)
//           );

//           setBonusRows([
//             {
//               id: Date.now(),
//               questionNo: "",
//               questionText: "",
//               bonusMarks: 0,
//               reason: "Reason to give Bonus Marks",
//               attempted: "Only attempted",
//               selected: false,
//             },
//           ]);
//         } else {
//           throw new Error("No questions found for selected set");
//         }
//       } catch (err) {
//         setAllQuestions([]);
//         setBonusRows([]);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Error fetching question data.</span>
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//         setActiveImg(ErrorImg);
//       }
//     };

//     fetchQuestionsForSet();
//   }, [selectedTest, selectedSet]);

//   function convertLatexToHTML(text) {
//     if (!text) return "";

//     const formatMathContent = (content) => {
//       return content
//         .replace(/\\left|\\right/g, "") // remove \left, \right
//         .replace(/\\text\{(.*?)\}/g, "$1") // replace \text{}
//         .replace(/(\^|\_)\{(.*?)\}/g, (match, type, val) =>
//           type === "^" ? `<sup>${val}</sup>` : `<sub>${val}</sub>`
//         )
//         .replace(/\\times/g, "&times;")
//         .replace(/\\degree|\\deg/g, "&deg;")
//         .replace(/\\ /g, " ");
//     };

//     return text
//       .replace(/\\\((.*?)\\\)/g, (_, content) => formatMathContent(content)) // inline math
//       .replace(
//         /\\\[(.*?)\\\]/gs,
//         (_, content) =>
//           `<div style="display:block; margin:8px 0;">${formatMathContent(
//             content
//           )}</div>`
//       )
//       .replace(/\^{(.*?)}/g, "<sup>$1</sup>") // fallback superscript
//       .replace(/_{(.*?)}/g, "<sub>$1</sub>") // fallback subscript
//       .replace(
//         /imgsrc=([^\s]+)/g,
//         (match, url) =>
//           `<img src="${url}" alt="question image" style="width: auto; margin: 8px 0; height: auto;" />`
//       );
//   }

//   const handleBonusChange = (updatedRows) => {
//     setBonusRows(updatedRows);
//   };

//   const handleSaveBonusCorrections = async () => {
//     // 1. Get all sets' bonus data from localStorage
//     const allData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
//     // 2. Flatten and map to API format
//     const payload = Object.entries(allData).flatMap(([set, rows]) =>
//       rows
//         .filter((row) => row.questionNo && row.bonusMarks) // Only send filled rows
//         .map((row) => ({
//           set,
//           question_no: Number(row.questionNo),
//           bonus_marks: Number(row.bonusMarks),
//           reason: row.reason || "",
//           apply_to_all: row.attempted === "All attempted" ? 1 : 0,
//         }))
//     );

//     if (payload.length === 0) {
//       alert("No bonus corrections to save.");
//       return;
//     }

//     // 3. Prepare API URL and headers
//     const url = `${EndPoints.PostTestMarksCorrectionv3}?test_schedule_id=${selectedTest?.id}&username=${userName}`;
//     // You may get username from localStorage or context
//     try {
//       const response = await POST.withToken(url, payload, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });
//       if (response?.status === 200) {
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>
//                   {response.message || "Test schedule created successfully!"}
//                 </span>
//               </div>
//             </div>
//           );
//           setIsMessageBoxVisible(true);
//           setActiveImg(SuccessImg);
//           setTimeout(() => window.location.reload(), 1000);
//         }
//         localStorage.removeItem("QuestionCorrectionDetails"); // Clear after success
//       } else {
//         // alert("Failed to save bonus corrections.");
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               {response.message || "Failed to save bonus corrections."}
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//         setActiveImg(ErrorImg);
//       }
//     } catch (err) {
//       alert("Error saving bonus corrections.");
//     }
//   };

//   useEffect(() => {
//     if (!requestedSet || requestedSet === selectedSet) return;

//     const saved = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
//     const currentRows = saved[selectedSet] || [];

//     if (selectedSet && currentRows.length > 0) {
//       const confirmChange = window.confirm(
//         "The corrections added will be lost if you change the set."
//       );
//       if (!confirmChange) {
//         setRequestedSet(null); // reset the requested set
//         return;
//       }
//     }

//     setSelectedSet(requestedSet); // safe to update
//   }, [requestedSet]);

//   return (
//     <>
//       <div className="Leftmargin-Main-DIV">
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             marginBottom: "20px",
//             width: "98%",
//           }}
//         >
//           <div
//             style={{
//               fontSize: "30px",
//               color: `${Colors.color1}`,
//               fontWeight: "400",
//             }}
//           >
//             Test Paper Bonus Marks 
//           </div>
//           <div>
//             <div className="row-cs-uni">
//               <button
//                 className="create-test-section-btn"
//                 style={{
//                   marginRight: "18px",
//                   boxShadow: `0px 4px 4px 0px ${Colors.color11}`,
//                 }}
//                 onClick={() => {
//                   window.location.reload();
//                 }}
//               >
//                 CANCEL
//               </button>
//               <button
//                 className="create-test-section-btn"
//                 style={{
//                   marginRight: "0px",
//                   boxShadow: `0px 4px 4px 0px ${Colors.color11}`,
//                 }}
//                 onClick={handleSaveBonusCorrections}
//               >
//                 SAVE
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="Header-1-C424342">TEST DETAIL</div>
//         <div className="Body-1-C424342">
//           <div className="row-cs">
//             <div className="col-cs">
//               <DropDown
//                 label="Course"
//                 style={{ width: "100%" }}
//                 setSelected={setSelectedCourse}
//                 options={courses.map((course) => ({
//                   label: course.course_name,
//                   id: course.course_id,
//                 }))}
//                 isRequired={true}
//               />
//             </div>
//             <div className="col-cs">
//               <DropDown
//                 label="Batch"
//                 style={{ width: "100%" }}
//                 setSelected={setSelectedBatch}
//                 options={batches.map((batch) => ({
//                   label: batch.batch_name,
//                   id: batch.batch_id,
//                 }))}
//                 isRequired={true}
//               />
//             </div>
//             <div className="col-cs">
//               {/* <div>test name</div> */}
//               <div style={{ width: "97.5%" }}>
//                 <SearchDropdown
//                   label="Test Name"
//                   initialOptions={testOptions}
//                   selected={selectedTest}
//                   onSelect={(test) => {
//                     setSelectedTest(test);
//                     setSelectedSet(null); // reset set when new test selected
//                   }}
//                   labelKey={(option) => option.label}
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="row-cs">
//             <div className="col-cs3-6">
//               {/* <div>Test Coordinator Name</div> */}
//               <InputComponent
//                 label="Test Coordinator Name"
//                 style={{ width: "100%", marginLeft: "3%" }}
//                 value={selectedTest?.cordinator_name || ""}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               {/* <div>Subjects</div> */}
//               <InputComponent
//                 label="Subjects"
//                 style={{ width: "96%", marginLeft: "2.8%" }}
//                 value={
//                   selectedTest?.subjects?.length > 0
//                     ? selectedTest.subjects.join(", ")
//                     : ""
//                 }
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//           </div>

//           <div className="row-cs">
//             <div className="col-cs">
//               {/* <div>Test Window Start</div> */}
//               <InputComponent
//                 label="Test Window Start"
//                 style={{ width: "100%" }}
//                 value={
//                   selectedTest?.start_date
//                     ? new Date(selectedTest.start_date).toLocaleString()
//                     : ""
//                 }
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               {/* <div>Test Window End</div> */}
//               <InputComponent
//                 label="Test Window End"
//                 style={{ width: "100%" }}
//                 value={
//                   selectedTest?.end_date
//                     ? new Date(selectedTest.end_date).toLocaleString()
//                     : ""
//                 }
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               <div></div>
//             </div>
//           </div>
//         </div>

//         <div className="Header-1-C424342" style={{ marginTop: "1.5%" }}>
//           BONUS MARKS
//         </div>
//         <div className="Body-1-C424342">
//           <div className="row-cs" style={{ marginBottom: "1%" }}>
//             <div className="col-cs">
//               {/* <div>Set Name</div> */}
//               {/* <DropDown
//                 label="Set Name"
//                 style={{ width: "100%" }}
//                 setSelected={setSelectedSet}
//                 options={(selectedTest?.set_names || []).map((set) => ({
//                   label: set,
//                   id: set,
//                 }))}
//                 isRequired={true}
//               /> */}
//               <DropDown
//                 label="Set Name"
//                 style={{ width: "100%" }}
//                 setSelected={setRequestedSet}
//                 options={(selectedTest?.set_names || []).map((set) => ({
//                   label: set,
//                   id: set,
//                 }))}
//                 isRequired={true}
//               />
//             </div>
//             <div className="col-cs">
//               <div></div>
//             </div>
//             <div className="col-cs">
//               <div></div>
//             </div>
//           </div>
//           {/* <BonusQuestionTable
//             rows={bonusRows}
//             onChange={setBonusRows}
//             allQuestions={allQuestions}
//           /> */}
//           <BonusQuestionTable
//             rows={bonusRows}
//             allQuestions={allQuestions}
//             onChange={handleBonusChange}
//             currentSet={selectedSet}
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// export default TestPaperBonusCorrection;

import React, { useEffect, useState } from "react";
// import "./quespapercorrection.css";
import BonusQuestionTable from "../../Components/BonusTable/BonusTable";
import { POST } from "../../Api/HttpsMethods";
import { GET } from "../../Api/HttpsMethods";
import EndPoints from "../../Api/EndPoints";
import DropDown from "../CreateBatch/DropdownCB";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import BlankDropdown from "../CreateQuestionsPaper/DppScheduling/BlankDropdown";
import InputComponent from "../CreateQuestionsPaper/TestScheduling/Input-testscheduling";
import Colors from "../../Constants/Colors";
import SearchDropdown from "../../Components/SearchDropdownforListDataSingleSelect/SearchdropdownforlistdataSingleSelect";
import SuccessImg from "../../Assets/Images/CommanImages/success.png";

const TestPaperBonusCorrection = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
}) => {
  useEffect(() => {
    localStorage.removeItem("QuestionCorrectionDetails");
  }, []);

  const [bonusRows, setBonusRows] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);

  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [testOptions, setTestOptions] = useState([]);

  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [selectedTest, setSelectedTest] = useState(null);
  const [selectedSet, setSelectedSet] = useState(null);
  const LOCAL_STORAGE_KEY = "QuestionCorrectionDetails";
  const [requestedSet, setRequestedSet] = useState(null);

  // Collapsible section states
  const [isTestDetailExpanded, setIsTestDetailExpanded] = useState(true);
  const [isBonusMarksExpanded, setIsBonusMarksExpanded] = useState(true);



  useEffect(() => {
    if (dataClient) {
      const userName =
        dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
      const clientBranchId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
      const clientId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

      sessionStorage.setItem("user_name", userName);
      sessionStorage.setItem("clientBranchId", clientBranchId);
      sessionStorage.setItem("clientId", clientId);
    }
  }, [dataClient]);

  const userName =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";

  // Fetch all courses
  useEffect(() => {
    const fetchCourses = async () => {
      const data = await GET.noToken(EndPoints.GetCourses, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      if (data) setCourses(data);
    };
    fetchCourses();
  }, []);

  // Fetch batches for selected course
  useEffect(() => {
    const fetchBatches = async () => {
      if (!selectedCourse) return;
      const url = `${EndPoints.GetBatchByCourse}?course_id=${selectedCourse}`;
      const data = await GET.noToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });

      if (data && Array.isArray(data[0])) setBatches(data[0]);
      else setBatches([]);

      setSelectedBatch(null);
    };
    fetchBatches();
  }, [selectedCourse]);

  // Fetch tests for selected batch
  useEffect(() => {
    const fetchTests = async () => {
      if (!selectedBatch) return;
      const url = `${EndPoints.GetTestSummarybyBatch}?batch_id=${selectedBatch}`;
      const response = await GET.withToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });

      if (response?.data && Array.isArray(response.data)) {
        const tests = response.data.map((test) => ({
          label: test.test_name,
          id: test.test_schedule_id,
          ...test,
        }));
        setTestOptions(tests);
      } else {
        setTestOptions([]);
      }
    };
    fetchTests();
  }, [selectedBatch]);

  // Fetch questions for selected test and set
  // useEffect(() => {
  //   const fetchQuestionsForSet = async () => {
  //     if (!selectedTest?.id || !selectedSet) return;
  //     try {
  //       const url = `${EndPoints.GetQuestionsfromSetName}?test_schedule_id=${selectedTest.id}&set_name=${selectedSet}`;
  //       const response = await GET.withToken(url, {
  //         setMessageBox,
  //         setIsMessageBoxVisible,
  //         setActiveImg,
  //         ErrorImg,
  //       });

  //       if (response?.status === 200 && Array.isArray(response.data)) {
  //         const allQs = response.data
  //           .filter((q) => q.ques_number != null)
  //           .map((q) => ({
  //             id: q.ques_id,
  //             ques_number: q.ques_number,
  //             ques_text: convertLatexToHTML(q.ques_text),
  //             special_status: q.special_status || false,
  //           }));

  //         setAllQuestions(allQs);

  //         // const existing = JSON.parse(
  //         //   localStorage.getItem("QuestionCorrectionDetails") || "{}"
  //         // );
  //         // existing[selectedSet] = allQs;
  //         // localStorage.setItem(
  //         //   "QuestionCorrectionDetails",
  //         //   JSON.stringify(existing)
  //         // );

  //         setBonusRows([
  //           {
  //             id: Date.now(),
  //             questionNo: "",
  //             questionText: "",
  //             bonusMarks: 0,
  //             reason: "Reason to give Bonus Marks",
  //             attempted: "Only attempted",
  //             selected: false,
  //           },
  //         ]);
  //       } else {
  //         throw new Error("No questions found for selected set");
  //       }
  //     } catch (err) {
  //       setAllQuestions([]);
  //       setBonusRows([]);
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>Error fetching question data.</span>
  //           </div>
  //         </div>
  //       );
  //       setIsMessageBoxVisible(true);
  //       setActiveImg(ErrorImg);
  //     }
  //   };

  //   fetchQuestionsForSet();
  // }, [selectedTest, selectedSet]);

  useEffect(() => {
    const fetchQuestionsForSet = async () => {
      if (!selectedTest?.id || !selectedSet) return;
      try {
        const url = `${EndPoints.GetQuestionsfromSetName}?test_schedule_id=${selectedTest.id}&set_name=${selectedSet}`;
        const response = await GET.withToken(url, {
          setMessageBox,
          setIsMessageBoxVisible,
          setActiveImg,
          ErrorImg,
        });

        if (response?.status === 200 && Array.isArray(response.data)) {
          const allQs = response.data
            .filter((q) => q.ques_number != null)
            .map((q) => ({
              id: q.ques_id,
              ques_number: q.ques_number,
              ques_text: convertLatexToHTML(q.ques_text),
              special_status: q.special_status || false,
            }));

          setAllQuestions(allQs);

          // REMOVE THESE LINES - Don't overwrite localStorage with questions
          // const existing = JSON.parse(
          //   localStorage.getItem("QuestionCorrectionDetails") || "{}"
          // );
          // existing[selectedSet] = allQs;
          // localStorage.setItem(
          //   "QuestionCorrectionDetails",
          //   JSON.stringify(existing)
          // );

          // This is fine - it resets the bonusRows state for display
          setBonusRows([
            {
              id: Date.now(),
              questionNo: "",
              questionText: "",
              bonusMarks: 0,
              reason: "Reason to give Bonus Marks",
              attempted: "Only attempted",
              selected: false,
            },
          ]);
        } else {
          throw new Error("No questions found for selected set");
        }
      } catch (err) {
        setAllQuestions([]);
        setBonusRows([]);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Error fetching question data.</span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
      }
    };

    fetchQuestionsForSet();
  }, [selectedTest, selectedSet]);


  function convertLatexToHTML(text) {
    if (!text) return "";

    const formatMathContent = (content) => {
      return content
        .replace(/\\left|\\right/g, "") // remove \left, \right
        .replace(/\\text\{(.*?)\}/g, "$1") // replace \text{}
        .replace(/(\^|\_)\{(.*?)\}/g, (match, type, val) =>
          type === "^" ? `<sup>${val}</sup>` : `<sub>${val}</sub>`
        )
        .replace(/\\times/g, "&times;")
        .replace(/\\degree|\\deg/g, "&deg;")
        .replace(/\\ /g, " ");
    };

    return text
      .replace(/\\\((.*?)\\\)/g, (_, content) => formatMathContent(content)) // inline math
      .replace(
        /\\\[(.*?)\\\]/gs,
        (_, content) =>
          `<div style="display:block; margin:8px 0;">${formatMathContent(
            content
          )}</div>`
      )
      .replace(/\^{(.*?)}/g, "<sup>$1</sup>") // fallback superscript
      .replace(/_{(.*?)}/g, "<sub>$1</sub>") // fallback subscript
      .replace(
        /imgsrc=([^\s]+)/g,
        (match, url) =>
          `<img src="${url}" alt="question image" style="width: auto; margin: 8px 0; height: auto;" />`
      );
  }

  const handleBonusChange = (updatedRows) => {
    setBonusRows(updatedRows);
  };

  // const handleSaveBonusCorrections = async () => {
  //   const allData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
  //   // 2. Flatten and map to API format
  //   const payload = Object.entries(allData).flatMap(([set, rows]) =>
  //     rows
  //       .filter((row) => row.questionNo && row.bonusMarks && row.questionId) // Only send filled rows with questionId
  //       .map((row) => ({
  //         set,
  //         question_no: Number(row.questionNo),
  //         parse_ques_set_question_id: Number(row.questionId), // Add this field
  //         bonus_marks: Number(row.bonusMarks),
  //         reason: row.reason || "",
  //         apply_to_all: row.attempted === "All" ? 1 : 0, // Also fixed: "All" instead of "All attempted"
  //       }))
  //   );

  //   if (payload.length === 0) {
  //     // alert("No bonus corrections to save.");
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <div style={{paddingLeft:"5px"}}>No bonus corrections to save
  //           </div>
  //         </div>
  //       </div>
  //     );
  //     setIsMessageBoxVisible(true);
  //     setActiveImg(ErrorImg);
  //     return;
  //   }

  //   // 3. Prepare API URL and headers
  //   const url = `${EndPoints.PostTestMarksCorrectionv3}?test_schedule_id=${selectedTest?.id}&username=${userName}`;
  //   // You may get username from localStorage or context
  //   try {
  //     const response = await POST.withToken(url, payload, {
  //       setMessageBox,
  //       setIsMessageBoxVisible,
  //       setActiveImg,
  //       ErrorImg,
  //     });
  //     if (response?.status === 200) {
  //       if (setMessageBox) {
  //         setMessageBox(
  //           <div className="Container-messageBOX">
  //             <div className="messagebox-insider1">
  //               <div className="loader-tc"></div>
  //               <span>
  //                 {response.message || "Test schedule created successfully!"}
  //               </span>
  //             </div>
  //           </div>
  //         );
  //         setIsMessageBoxVisible(true);
  //         setActiveImg(SuccessImg);
  //         setTimeout(() => window.location.reload(), 1000);
  //       }
  //       localStorage.removeItem("QuestionCorrectionDetails"); // Clear after success
  //     } else {
  //       // alert("Failed to save bonus corrections.");
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             {response.message || "Failed to save bonus corrections."}
  //           </div>
  //         </div>
  //       );
  //       setIsMessageBoxVisible(true);
  //       setActiveImg(ErrorImg);
  //     }
  //   } catch (err) {
  //     alert("Error saving bonus corrections.");
  //   }
  // };


  const handleSaveBonusCorrections = async () => {
    const allData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");

    // Check for rows with 0 or null bonus marks before creating payload
    const invalidRows = [];
    Object.entries(allData).forEach(([set, rows]) => {
      rows.forEach((row, index) => {
        if (row.questionNo && row.questionId) {
          const bonusMarks = Number(row.bonusMarks);
          if (!bonusMarks || bonusMarks === 0) {
            invalidRows.push({
              set,
              questionNo: row.questionNo,
              rowIndex: index + 1
            });
          }
        }
      });
    });

    // Show warning if there are invalid bonus marks
    if (invalidRows.length > 0) {
      const invalidRowsMessage = invalidRows
        .map(r => `Set ${r.set}, Question #${r.questionNo}`)
        .join(", ");

      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <div style={{ paddingLeft: "5px" }}>
              Please enter valid bonus marks ( greater than 0 ) for: {invalidRowsMessage}
            </div>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }

    // 2. Flatten and map to API format
    const payload = Object.entries(allData).flatMap(([set, rows]) =>
      rows
        .filter((row) => row.questionNo && row.bonusMarks && row.questionId) // Only send filled rows with questionId
        .map((row) => ({
          // set,
          // question_no: Number(row.questionNo),
          parse_ques_set_question_id: Number(row.questionId),
          bonus_marks: Number(row.bonusMarks),
          reason: row.reason || "",
          apply_to_all: row.attempted === "All" ? 1 : 0,
        }))
    );

    if (payload.length === 0) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <div style={{ paddingLeft: "5px" }}>
              No bonus corrections to save
            </div>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }

    // 3. Prepare API URL and headers
    const url = `${EndPoints.PostTestMarksCorrectionv3}?test_schedule_id=${selectedTest?.id}&username=${userName}`;

    try {
      const response = await POST.withToken(url, payload, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });

      if (response?.status === 200) {
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>
                  {response.message || "Test schedule created successfully!"}
                </span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(SuccessImg);
          setTimeout(() => window.location.reload(), 1000);
        }
        localStorage.removeItem("QuestionCorrectionDetails");
      } else {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              {response.message || "Failed to save bonus corrections."}
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
      }
    } catch (err) {
      alert("Error saving bonus corrections.");
    }
  };

  useEffect(() => {
    if (!requestedSet || requestedSet === selectedSet) return;

    const saved = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "{}");
    const currentRows = saved[selectedSet] || [];

    if (selectedSet && currentRows.length > 0) {
      const confirmChange = window.confirm(
        "The corrections added will be lost if you change the set."
      );
      if (!confirmChange) {
        setRequestedSet(null); // reset the requested set
        return;
      }
    }

    setSelectedSet(requestedSet); // safe to update
  }, [requestedSet]);

  return (
    <>
      <div className="Leftmargin-Main-DIV">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
            width: "98%",
          }}
        >
          <div
            style={{
              fontSize: "30px",
              color: `${Colors.color1}`,
              fontWeight: "400",
            }}
          >
            Test Paper Bonus Marks
          </div>
          <div>
            <div className="row-cs-uni">
              <button
                className="create-test-section-btn"
                style={{
                  marginRight: "18px",
                  boxShadow: `0px 4px 4px 0px ${Colors.color11}`,
                }}
                onClick={() => {
                  window.location.reload();
                }}
              >
                CANCEL
              </button>
              <button
                className="create-test-section-btn"
                style={{
                  marginRight: "0px",
                  boxShadow: `0px 4px 4px 0px ${Colors.color11}`,
                }}
                onClick={handleSaveBonusCorrections}
              >
                SAVE
              </button>
            </div>
          </div>
        </div>

        {/* TEST DETAIL Section with Toggle */}
        <div
          className="Header-1-C424342"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => setIsTestDetailExpanded(!isTestDetailExpanded)}
        >
          <span style={{ marginBottom: "4px" }}>TEST DETAIL</span>
          <span
            style={{
              fontSize: isTestDetailExpanded ? "45px" : "38px", // minus bigger, plus smaller
              color: Colors.color3,
              marginRight: "10px",
            }}
          >
            {isTestDetailExpanded ? "−" : "+"}
          </span>
        </div>

        {isTestDetailExpanded && (
          <div className="Body-1-C424342">
            <div className="row-cs">
              <div className="col-cs">
                <DropDown
                  label="Course"
                  style={{ width: "100%" }}
                  setSelected={setSelectedCourse}
                  options={courses.map((course) => ({
                    label: course.course_name,
                    id: course.course_id,
                  }))}
                  isRequired={true}
                />
              </div>
              <div className="col-cs">
                <DropDown
                  label="Batch"
                  style={{ width: "100%" }}
                  setSelected={setSelectedBatch}
                  options={batches.map((batch) => ({
                    label: batch.batch_name,
                    id: batch.batch_id,
                  }))}
                  isRequired={true}
                />
              </div>
              <div className="col-cs">
                <div style={{ width: "97.5%" }}>
                  <SearchDropdown
                    label="Test Name"
                    initialOptions={testOptions}
                    selected={selectedTest}
                    onSelect={(test) => {
                      setSelectedTest(test);
                      setSelectedSet(null); // reset set when new test selected
                    }}
                    labelKey={(option) => option.label}
                  />
                </div>
              </div>
            </div>

            <div className="row-cs">
              <div className="col-cs3-6">
                <InputComponent
                  label="Test Coordinator Name"
                  style={{ width: "100%", marginLeft: "3%" }}
                  value={selectedTest?.cordinator_name || ""}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div className="col-cs">
                <InputComponent
                  label="Subjects"
                  style={{ width: "96%", marginLeft: "2.8%" }}
                  value={
                    selectedTest?.subjects?.length > 0
                      ? selectedTest.subjects.join(", ")
                      : ""
                  }
                  isRequired={false}
                  disable={true}
                />
              </div>
            </div>

            <div className="row-cs">
              <div className="col-cs">
                <InputComponent
                  label="Test Window Start"
                  style={{ width: "100%" }}
                  value={
                    selectedTest?.start_date
                      ? new Date(selectedTest.start_date).toLocaleString()
                      : ""
                  }
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div className="col-cs">
                <InputComponent
                  label="Test Window End"
                  style={{ width: "100%" }}
                  value={
                    selectedTest?.end_date
                      ? new Date(selectedTest.end_date).toLocaleString()
                      : ""
                  }
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div className="col-cs">
                <div></div>
              </div>
            </div>
          </div>
        )}

        {/* BONUS MARKS Section with Toggle */}
        <div
          className="Header-1-C424342"
          style={{
            marginTop: "1.5%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",

          }}
          onClick={() => setIsBonusMarksExpanded(!isBonusMarksExpanded)}
        >
          <span style={{ marginBottom: "4px" }}> BONUS MARKS</span>
          <span
            style={{
              fontSize: isBonusMarksExpanded ? "45px" : "38px",
              color: Colors.color3,
              marginRight: "10px",
            }}
          >
            {isBonusMarksExpanded ? "−" : "+"}
          </span>

        </div>

        {isBonusMarksExpanded && (
          <div className="Body-1-C424342" style={{ marginBottom: "15%", }}>
            <div className="row-cs" style={{ marginBottom: "1%" }}>
              <div className="col-cs">
                <DropDown
                  label="Set Name"
                  style={{ width: "100%" }}
                  setSelected={setRequestedSet}
                  options={(selectedTest?.set_names || []).map((set) => ({
                    label: set,
                    id: set,
                  }))}
                  isRequired={true}
                />
              </div>
              <div className="col-cs">
                <div></div>
              </div>
              <div className="col-cs">
                <div></div>
              </div>
            </div>
            <BonusQuestionTable
              rows={bonusRows}
              allQuestions={allQuestions}
              onChange={handleBonusChange}
              currentSet={selectedSet}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default TestPaperBonusCorrection;
